import instance from '../../api';
import { IRequest, IJsonItemSave, IJsonItemUpdate, ILoadedReport } from './interface';

export const loadReport = (reportId: number): Promise<ILoadedReport> => {
  return instance()
    .post('/jsonStorage/load', {
      jsonStorageId: reportId,
    })
    .then((response) => response.data);
};

export const deleteReport = (reportId: number): Promise<ILoadedReport> => {
  return instance()
    .post('/jsonStorage/delete', {
      jsonStorageId: reportId,
    })
    .then((response) => response.data);
};

export const getSubordinates = (data: IRequest) => {
  return instance()
    .post('/subordinateReport/report', data)
    .then((response) => response.data);
};

export const getExcel = (data: IRequest) => {
  return instance()
    .post('/subordinateReport/excel', data, {
      responseType: 'blob',
    })
    .then((response) => response.data);
};

export const saveJsonItem = (jsonStorageItem: IJsonItemSave) => {
  return instance()
    .post('/jsonStorage/save', jsonStorageItem)
    .then((response) => response.data);
};

export const updateJsonItem = (jsonStorageItem: IJsonItemUpdate) => {
  return instance()
    .post('/jsonStorage/update', jsonStorageItem)
    .then((response) => response.data);
};
